import { AnalyticsDataFrameBarChartController } from './analytics-data-frame-bar-chart.controller'

function analyticsDataFrameBarChart () {
  return {
    restrict: 'E',
    scope: {
      data: '<',
      slug: '<',
      filterParams: '<',
      loadingDataFrames: '=',
      noEmptyModeDescription: '<',
      fullWidth: '<'
    },
    templateUrl: '/analytics/directives/analytics-data-frame-bar-chart/analytics-data-frame-bar-chart-directive.html?$$REVISION$$',
    controller: AnalyticsDataFrameBarChartController
  }
}

export { analyticsDataFrameBarChart }
